import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdAddBox } from "react-icons/md";
import { Modal, Button } from "react-bootstrap";
import colors from "../../config/colors";
import apiClient, { initializeApiClient } from "../../api/apiClient";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";

export default () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [vehicleToDelete, setVehicleToDelete] = useState(null);

  const fetch = async () => {
    setLoading(true);
    try {
      initializeApiClient();
      const response = await apiClient.get("/vehicles/vehicle/");

      if (response.status === 200) {
        setVehicles(response.data);
      } else {
        console.error("Error fetching vehicles:", response.status);
        toast.error("Failed to fetch vehicles");
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      toast.error("Failed to fetch vehicles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const handleDeleteClick = (vehicle) => {
    setVehicleToDelete(vehicle);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setVehicleToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (vehicleToDelete) {
      setLoading(true);
      try {
        const response = await apiClient.delete(
          `/vehicles/vehicle/${vehicleToDelete.id}/`
        );
        if (response.status === 200) {
          toast.success("Vehicle Deleted");
          setTimeout(() => {
            handleCloseModal();
            fetch();
          }, 1000);
        } else {
          console.error("Error deleting vehicle:", response.status);
          toast.error("Failed to delete vehicle");
          handleCloseModal();
        }
      } catch (error) {
        console.error("Error deleting vehicle:", error);
        toast.error("Failed to delete vehicle");
        handleCloseModal();
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="site-content h-100">
      <div className="">
        <div className="site-content-body">
          <div className="main_bg_color h-100">
            <div className="container-fluid">
              <div className="row py-3">
                {!loading ? (
                  vehicles.map((vehicle) => (
                    <div
                      className="col-lg-4 col-md-6 sm-col-12 px-4 mb-5"
                      key={vehicle.id}
                    >
                      <div>
                        <div className="card card_border div_posetion">
                          <img
                            className=""
                            src={vehicle.frontside_image}
                            alt="Card image"
                            style={{ width: "100%", height: "200px" }}
                          />
                          <div className="photo_button d-flex justify-content-between">
                            <button className="px-3 py-2 rounded-pill bg-dark">
                              <b>{vehicle.vehicle_type.name}</b>
                            </button>
                          </div>
                          <div className="d-flex flex-column edit_del_button">
                            <i
                              className="bi bi-trash fs-3 text-danger pb-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteClick(vehicle)}
                            />
                            <Link
                              to="/vehicleowneraddvehicle"
                              state={{ item: vehicle }}
                            >
                              <i className="bi bi-pencil text-primary fs-3" />
                            </Link>
                          </div>
                          <div className="job_bg py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                            <p className="mb-1">
                              Vehicle:
                              <span>{`${vehicle.vehicle_year},${vehicle.vehicle_model}`}</span>
                            </p>
                            <p className="mb-1">
                              License Plate:{" "}
                              <span>{vehicle.license_plate}</span>
                            </p>
                            {vehicle.vehicle_length !== 0 && (
                              <p className="">
                                Vehicle Length:
                                <span>{vehicle.vehicle_length}ft</span>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center mt-3">
                    <h1>
                      <CircularProgress />
                    </h1>
                  </div>
                )}
              </div>
              <div className="px-4 mb-5 d-flex justify-content-center align-items-center">
                <div className="">
                  <Link
                    to={"/vehicleowneraddvehicle"}
                    style={{ textDecoration: "none" }}
                  >
                    <MdAddBox color={colors.primary} size={200} />
                    <h5
                      className="d-flex justify-content-center"
                      style={{ color: "#005E9D" }}
                    >
                      Add Vehicle
                    </h5>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this vehicle?
          {vehicleToDelete && (
            <p>
              {vehicleToDelete.vehicle_year} {vehicleToDelete.vehicle_model}{" "}
              (License Plate: {vehicleToDelete.license_plate})
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
